(function() {
  'use strict';

  angular.module('component.eventTypes')
    .component('eventTypeSection', {
      templateUrl: 'app/components/event-types/event-type-section.html',
      controller: 'EventTypeSectionController',
      controllerAs: 'sectionCtrl',
      bindings: {
        eventTypeId: '<',
        sectionId: '<'
      }
    });
})();
